"use client";
import React from 'react';
import Link from 'next/link';

const CommunityHero = () => {
  return (
    <div className="my-3 my-md-5 py-4 mx-auto col-12 col-md-12 col-xxl-12 fade-in-up">
      <div 
        className="card border-0 shadow-lg overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.9) 0%, rgba(30, 30, 30, 0.95) 100%)',
          borderRadius: '24px',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Background Pattern */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.05,
            backgroundImage: 'radial-gradient(circle at 2px 2px, #FFD52E 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}
        />
        
        <div className="card-body p-4 p-md-5 text-center text-white position-relative">
          {/* Icon */}
          <div className="mb-3">
            <i 
              className="bi bi-people-fill"
              style={{
                fontSize: 'clamp(2.5rem, 8vw, 4rem)',
                color: '#FFD52E',
                textShadow: '0 4px 20px rgba(255, 213, 46, 0.3)'
              }}
            />
          </div>

          {/* Headline */}
          <h1 
            className="fw-bold mb-3"
            style={{
              fontSize: 'clamp(1.75rem, 5vw, 2.5rem)',
              textShadow: '0 2px 10px rgba(0,0,0,0.5)',
              lineHeight: '1.2'
            }}
          >
            انضم إلى مجتمع فيجماوية
          </h1>

          {/* Subheadline */}
          <p 
            className="mb-4 text-light"
            style={{
              fontSize: 'clamp(1rem, 3vw, 1.25rem)',
              maxWidth: '600px',
              margin: '0 auto 1.5rem'
            }}
          >
            تعلم، شارك، وتقدم مع آلاف المصممين المميزين في مجتمع عربي متكامل
          </p>

          {/* Social Proof */}
          <div className="mb-4">
            <p className="text-light mb-2" style={{ fontSize: 'clamp(0.875rem, 2.5vw, 1rem)' }}>
              <i className="bi bi-check-circle-fill text-warning me-2"></i>
              انضم إلى <strong className="text-warning">8500+</strong> عضو في المجتمع
            </p>
          </div>

          {/* CTAs */}
          <div className="d-flex flex-column flex-md-row gap-3 justify-content-center align-items-center">
            <Link
              href="/signup"
              className="btn btn-lg px-4 py-3 rounded-pill fw-bold text-dark"
              style={{
                background: 'linear-gradient(135deg, #FFD52E 0%, #FF8C00 100%)',
                border: 'none',
                minWidth: '200px',
                fontSize: 'clamp(1rem, 3vw, 1.125rem)',
                boxShadow: '0 4px 15px rgba(255, 213, 46, 0.4)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 8px 25px rgba(255, 213, 46, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(255, 213, 46, 0.4)';
              }}
            >
              <i className="bi bi-person-plus-fill me-2"></i>
              انضم الآن
            </Link>

            <Link
              // href="#community-stats"
              href="#value-proposition"
              className="btn btn-outline-light btn-lg px-4 py-3 rounded-pill fw-bold"
              style={{
                minWidth: '200px',
                fontSize: 'clamp(1rem, 3vw, 1.125rem)',
                borderWidth: '2px',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              <i className="bi bi-info-circle me-2"></i>
              استكشف المحتوى
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityHero;
